import { createSelector } from '@ngrx/store';
import { EasyDgdDataState } from './easydgd-data.reducer';
import { EasyDgdStep } from '@hazmatsuite-next/easydgd-lib';
import { StepModel } from '@hazmatsuite-next/ui';


export const selectTransportMode = (state: { easyDgdState: EasyDgdDataState }) => state.easyDgdState.transportMode;
export const selectStep = (state: { easyDgdState: EasyDgdDataState }) => state.easyDgdState.step;
export const selectSteps = (state: { easyDgdState: EasyDgdDataState }) => state.easyDgdState.steps;
export const selectInitialized = (state: { easyDgdState: EasyDgdDataState }) => state.easyDgdState.initialized;

export const selectStepState = createSelector(
  selectStep, selectSteps,
  (currentStep: EasyDgdStep, steps: StepModel<EasyDgdStep>[]) => {
    return steps.map(step => ({
      ...step,
      isDisabled: (step.stepType as EasyDgdStep) > currentStep,
      isActive: (step.stepType as EasyDgdStep) === currentStep,
    })
    );
  }
);

export const selectInitialStepRoute = createSelector(
  selectStepState,
  (steps: StepModel<EasyDgdStep>[]) => {
    const activeStep = steps?.find((step) => step.isActive);
    return activeStep?.relativeRoute;
  }
);

